import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { usePublishUserInteraction } from "@geome/react-next/lib/hooks/userInteraction";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { OptionalLink } from "../optionalLink";
export const LinksList = ({ className, links }) => {
    const [onClickLink] = usePublishUserInteraction("links-list", "click");
    const { translate } = useI18n();
    const translatedLinks = useMemo(() => links.map((l) => {
        if (l.text) {
            const { translationToken: _, ...link } = l;
            return link;
        }
        if (l.translationToken) {
            const { translationToken, ...link } = l;
            return {
                ...link,
                text: translate(translationToken),
            };
        }
        // this return should never be reached - can remove it if TS gets smarter
        return l;
    }), [links, translate]);
    return (_jsx(_Fragment, { children: translatedLinks.map(({ active, link, hideHrefIfActive, text, newTab }, index) => (_jsx(OptionalLink, { className: `${className} ${active ? "is-active" : ""}`, href: active && hideHrefIfActive ? null : link, target: newTab ? "_blank" : "", onClick: () => onClickLink({ href: link, text }), children: text }, `${index}-${link}`))) }));
};
